import { useEffect, useState } from "react";
import patientController from "../../../../apis/Controllers/PatientController/patient.controller";
import { useNavigate } from "react-router-dom";


const PatientListFunctions = () => {
    const [showFilterModal, setShowFilterModal] = useState(false);
    const [showLogin, setShowLogin] = useState(false);
    const [searchInput, setSearchInput] = useState("");
    const [patientListing, setPatineListing] = useState([]);
    // -------------------PAZINATION ----------------------
    const [page, setPage] = useState(1);
    const [count, setCount] = useState(0);
    const [totalPages, setTotalPages] = useState([]);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    let navigate = useNavigate();


    // useEffect(() => {
    //     if (count) {
    //         handlePages(count);
    //     }
    // },[count]);


    // const handlePages = (count) => {
    //     let array = [...totalPages]
    //     const data = parseInt(count);
    //     const totalPage = Math.ceil(data / itemsPerPage);
    //     for (let i = 1; i <= totalPage; i++) {
    //         array.push(i)
    //     }
    //     setTotalPages(array);
    // };


    const handleChange = (e) => {
        setSearchInput(e.target.value);
    };


    const getPatientListing = async () => {
        let response = await patientController.patientListing();
        if (response && response.status) {
            setPatineListing(response.data)
        }
        else {
            setPatineListing([]);
        }
    };


    
    // const handleBackClick = () => {
    //     if (page > 1) {
    //         setPage(page - 1);
    //     }
    //     else {
    //         setPage(1);
    //     }
    // };


    // const handleNextClick = () => {
    //     if (page >= 1 && page < totalPages.length) {
    //         setPage(page + 1);
    //     }
    //     else {
    //         setPage(page);
    //     }
    // };
    
    return {
        setShowFilterModal,
        showFilterModal,
        setShowLogin,
        showLogin,
        setSearchInput,
        searchInput,
        handleChange,
        getPatientListing,
        patientListing,
        navigate,
    }
};

export default PatientListFunctions;